<template>
  <div v-if="props.facilities" class="flex flex-col">
    <div v-for="facility in props.facilities" :key="facility.id" class="flex gap-2" :class="props.itemClass">
      <svg-icon name="check" class="size-6 text-green-40" />
      <p class="text-base">{{ facility.name }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { EatigoBranchTag } from '@/types/api'

interface Props {
  facilities: EatigoBranchTag[]
  itemClass?: string
}

const props = defineProps<Props>()
</script>
